import _navbar from './_layout/Navbar.vue'
import _boxlogin from './_login/_boxlogin.vue'
import _contentlogin from './_login/_content.vue'
import _technologylogin from './_login/Login.vue'
import _technologyloginGuest from './_login/LoginGuest.vue'
// Loading
// import _fullLoading from './_template/FullLoading.vue'
import _overlayLoading from './_template/OverlayLoading.vue'
// Template
import _titleName from './_template/Title.vue'
// Dashboard
import _dashboardTitle from './_dashboard/Title.vue'
import _dashboardFilterOverall from './_dashboard/FilterOverall.vue'
import _dashboardOverview from './_dashboard/Overview.vue'
import _dashboardGraph from './_dashboard/Graph.vue'
// Org Chart
import _orgchartManage from './_orgchart/orgchartManage.vue'
import _orgchartProfile from './_template/CardProfile.vue'
import _orgchartMainmanage from './_orgchart/orgchartMainManage.vue'
import _orgchartCompany from './_orgchart/orgchartOfCompany.vue'
// Update Org Chart
import _updateTitleOrgchart from './_template/updateorgchart/title.vue'
import _updateOrgchart from './_template/updateorgchart/update.vue'
// Manage
// Manage Employee
import _manageEmployee from './manageEmployee/overviewEmployee.vue'
// import _manageCreateEmployee from './_manageemployee/_create/createNewEmployee.vue' // เก่า
import _manageCreateEmployee from './_manageemployee/_create/createEmployee.vue' // ใหม่

import _manageDivision from './manageDivision/overviewDivision.vue'
import _manageLineofwork from './_managelineofwork/_overview/ManageLineofwork.vue'
import _manageLineofworkView from './_managelineofwork/manageView.vue'
import _manageLineofworkCreate from './_managelineofwork/manageCreate.vue'
import _manageLineofworkOrgchart from './_managelineofwork/manageOrgchart.vue'
import _manageAgency from './_manageagency/_overview/manageAgency.vue'
import _manageAgencyView from './_manageagency/manageView.vue'
import _manageAgencyCreate from './_manageagency/manageCreate.vue'
import _manageWorkgroup from './_manageworkgroup/_overview/manageWorkgroup.vue'
import _manageWorkgroupView from './_manageworkgroup/manageView.vue'
import _manageWorkgroupCreate from './_manageworkgroup/manageCreate.vue'
import _manageCompany from './manageCompany/overview.vue'
import _createCompanyGroup from './manageCompany/groupCompany/createGroupCompany.vue'
import _createCompany from './manageCompany/createCompany.vue'
import _createDivision from './manageDivision/createDivision.vue'
// RA Services
import _authorityservicesMyServiceList from './_authorityservices/myServiceList.vue'
import _authorityservicesMyRequestServiceList from './_authorityservices/myRequestServiceList.vue'
import _authorityservicesCreateRequest from './_authorityservices/_create/create.vue'
import _settingservice from './_authorityservices/settingService.vue'

export const navbar = _navbar
export const Boxlogin = _boxlogin
export const Contentlogin = _contentlogin
export const Technnologylogin = _technologylogin
export const TechnnologyloginGuest = _technologyloginGuest
// Loading
export { default as FullLoading } from './_template/FullLoading.vue'
export const OverlayLoading = _overlayLoading
// Template
export const TitleName = _titleName
// Dashboard
export const DashboardTitle = _dashboardTitle
export const DashboardFilterOverall = _dashboardFilterOverall
export const DashboardOverview = _dashboardOverview
export const DashboardGraph = _dashboardGraph
// Org Chart
export const OrgchartManage = _orgchartManage
export const OrgchartProfile = _orgchartProfile
export const OrgchartMainManage = _orgchartMainmanage
export const OrgchartOfCompany = _orgchartCompany
// Manage Org Chart
export const UpdateTitleOrgchart = _updateTitleOrgchart
export const UpdateOrgchart = _updateOrgchart
// Manage
// Manage Employee
export const ManageEmployee = _manageEmployee
export const ManageCreateEmployee = _manageCreateEmployee
//
export const ManageDivision = _manageDivision
export const ManageCompany = _manageCompany
export const ManageLineofwork = _manageLineofwork
export const ManageLineofworkView = _manageLineofworkView
export const ManageLineofworkCreate = _manageLineofworkCreate
export const ManageLineofworkOrgchart = _manageLineofworkOrgchart
export const ManageAgency = _manageAgency
export const ManageAgencyView = _manageAgencyView
export const ManageAgencyCreate = _manageAgencyCreate
export const ManageWorkgroup = _manageWorkgroup
export const ManageWorkgroupView = _manageWorkgroupView
export const ManageWorkgroupCreate = _manageWorkgroupCreate
export const CreateGroupCompany = _createCompanyGroup
export const CreateCompany = _createCompany
export const CreateDivision = _createDivision
// RA Services
export const MyServiceList = _authorityservicesMyServiceList
export const MyRequestServiceList = _authorityservicesMyRequestServiceList
export const CreateRequest = _authorityservicesCreateRequest
export const SettingServices = _settingservice
